import { render, staticRenderFns } from "./backButton.vue?vue&type=template&id=7463d915&scoped=true&"
import script from "./backButton.vue?vue&type=script&lang=js&"
export * from "./backButton.vue?vue&type=script&lang=js&"
import style0 from "./backButton.vue?vue&type=style&index=0&id=7463d915&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463d915",
  null
  
)

export default component.exports